define([], ()=> {
    return function (subFlows, branchOnProductCodeFn) {

        return function (step, junction) {

            //start with the availability check if not in agent quote
            // junction(subFlows.availability.entry, true);
            step(subFlows.mfpFlows.mfpFlow.entry, true);
            //subFlows.availability.exits.productAvailable.onNext.branch(
            //    branchOnProductCodeFn(subFlows.paFlows, subFlows.hoFlows, subFlows.cpFlows, subFlows.mfpFlows, 'contactDetails')
            //);
        };
    };
});



// WEBPACK FOOTER //
// ../common/js/src/integration/quoteandbind/config/_flowBegining.js